<template>
  <Layout>  
    <div>
        <b-spinner type="grow" v-if="!apiConsumer"></b-spinner>
    
        <div v-else>
          <b-row>
            <div class="col"> 
              <div class="text-right">
                <a href="/logout" class="text-danger">
                  <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                  {{ $t('navbar.dropdown.profile.list.logout') }}
                </a>
              </div>
              <h2>{{ apiConsumer.title }}</h2>
            </div>
          </b-row>
          <b-row>
            <b-col>
              <b-row>
                <div class="col-12">
                  <button @click="$router.go(-1)" type="button" class="btn btn-secondary m-2">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    {{ $t("go-back") }}
                  </button>
                </div>
              </b-row>
    
              <b-tabs content-class="mt-3">
                <b-tab title="API Consumer bearbeiten" active>
                  <api-consumer-edit :apiConsumer="apiConsumer"/>
                </b-tab>
                <b-tab lazy title="API Zugriff">
                  <api-access-list :id="apiConsumer.id" :company-id="apiConsumer.id"/>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </div>
      </div>
  </Layout>
</template>

<script>
import { adminService } from "@/helpers/services/admin/adminService";
import ApiAccessList from "@/router/views/admin/api-consumers/api-access/api-access-list";
import ApiConsumerEdit from "@/router/views/admin/api-consumers/api-consumer-edit";
import Layout from "@/router/layouts/admin";

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {ApiAccessList, ApiConsumerEdit, Layout},
  name: "ApiConsumerOverview",
  data() {
    return {
      apiConsumer: null,
    }
  },
  methods: {
  },
  created() {
    adminService.fetchApiConsumerById(this.id)
    .then(t => this.apiConsumer = t);
  }
}
</script>

<style>

</style>